import { render, staticRenderFns } from "./PostEditorPalette.vue?vue&type=template&id=536d332c&"
import script from "./PostEditorPalette.vue?vue&type=script&lang=js&"
export * from "./PostEditorPalette.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorPalette.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports